import { createSlice } from '@reduxjs/toolkit';
import { initializeSuccess } from '../actions';

export type Permission = { available: boolean } | null;

export interface SessionPermissionsState {
  adwords: Permission;
  calendar: Permission;
  customers: Permission;
  dashboard: Permission;
  feedback: Permission;
  hr: Permission;
  insights: Permission;
  location: Permission;
  marketplace: Permission;
  messenger: Permission;
  networks: Permission;
  newsletter: Permission;
  reminders: Permission;
  reportings: Permission;
  resources: Permission;
  services: Permission;
  settings: Permission;
  shiftplan: Permission;
  transactions: Permission;
  websiteDuda: Permission;
  webWidgets: Permission;
}

export const initialState: SessionPermissionsState = {
  adwords: null,
  calendar: null,
  customers: null,
  dashboard: null,
  feedback: null,
  hr: null,
  insights: null,
  location: null,
  marketplace: null,
  messenger: null,
  networks: null,
  newsletter: null,
  reminders: null,
  reportings: null,
  resources: null,
  services: null,
  settings: null,
  shiftplan: null,
  transactions: null,
  websiteDuda: null,
  webWidgets: null,
};

const sessionPermissionsSlice = createSlice({
  name: 'sessionPermissions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initializeSuccess, (state, action) => {
      const {
        meta: {
          adwords,
          hr,
          insights,
          reportings,
          location,
          marketplace,
          messenger,
          networks,
          newsletter,
          reminders,
          resources,
          services,
          settings,
          shiftplan,
          transactions,
          dashboard,
          calendar,
          customers,
          feedback,
          web_widgets: webWidgets,
          website_duda: websiteDuda,
        },
      } = action.payload.sessionPermissions;

      state.adwords = adwords;
      state.calendar = calendar;
      state.customers = customers;
      state.dashboard = dashboard;
      state.feedback = feedback;
      state.hr = hr;
      state.insights = insights;
      state.location = location;
      state.marketplace = marketplace;
      state.messenger = messenger;
      state.networks = networks;
      state.newsletter = newsletter;
      state.reminders = reminders;
      state.reportings = reportings;
      state.resources = resources;
      state.services = services;
      state.settings = settings;
      state.shiftplan = shiftplan;
      state.transactions = transactions;
      state.websiteDuda = websiteDuda;
      state.webWidgets = webWidgets;
    });
  },
});

export const sessionPermissionsReducer = sessionPermissionsSlice.reducer;
